__webpack_require__.p = "/techcraft/";